import { render, staticRenderFns } from "./CaLogo.vue?vue&type=template&id=0b8ce2ee&scoped=true&"
import script from "./CaLogo.vue?vue&type=script&lang=ts&"
export * from "./CaLogo.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./CaLogo.vue?vue&type=style&index=0&id=0b8ce2ee&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0b8ce2ee",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8ce2ee')) {
      api.createRecord('0b8ce2ee', component.options)
    } else {
      api.reload('0b8ce2ee', component.options)
    }
    module.hot.accept("./CaLogo.vue?vue&type=template&id=0b8ce2ee&scoped=true&", function () {
      api.rerender('0b8ce2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/CaLogo.vue"
export default component.exports